(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sw-uniform-finder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{if(!event.target.matches('.sw-uniform-filter-form'))return;event.target.querySelectorAll('select').forEach(select=>{select.disabled=!select.value})});
  } catch(e) { console.error(e); }
})();

})();
